"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMultipleElementsWithLocatorError = exports.isNoElementWithLocatorError = exports.MultipleElementsWithLocatorError = exports.NoElementWithLocatorError = exports.ErrorTypes = void 0;
__exportStar(require("./utils"), exports);
__exportStar(require("./key-types"), exports);
var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["NO_ELEMENTS_WITH_SELECTOR"] = "no-elements-with-selector";
    ErrorTypes["MULTIPLE_ELEMENTS_WITH_SELECTOR"] = "multiple-elements-with-selector";
})(ErrorTypes = exports.ErrorTypes || (exports.ErrorTypes = {}));
var NoElementWithLocatorError = /** @class */ (function (_super) {
    __extends(NoElementWithLocatorError, _super);
    function NoElementWithLocatorError(locator) {
        var _this = _super.call(this, "Cannot find element with locator: " + locator) || this;
        _this.type = ErrorTypes.NO_ELEMENTS_WITH_SELECTOR;
        return _this;
    }
    return NoElementWithLocatorError;
}(Error));
exports.NoElementWithLocatorError = NoElementWithLocatorError;
var MultipleElementsWithLocatorError = /** @class */ (function (_super) {
    __extends(MultipleElementsWithLocatorError, _super);
    function MultipleElementsWithLocatorError(count, locator) {
        var _this = _super.call(this, "Found " + count + " elements with locator [" + locator + "]. Only 1 is expected. This is either a bug or not-specific-enough locator") || this;
        _this.type = ErrorTypes.MULTIPLE_ELEMENTS_WITH_SELECTOR;
        return _this;
    }
    return MultipleElementsWithLocatorError;
}(Error));
exports.MultipleElementsWithLocatorError = MultipleElementsWithLocatorError;
exports.isNoElementWithLocatorError = function (e) {
    var type = e.type || '';
    return type === ErrorTypes.NO_ELEMENTS_WITH_SELECTOR;
};
exports.isMultipleElementsWithLocatorError = function (e) {
    var type = e.type || '';
    return type === ErrorTypes.MULTIPLE_ELEMENTS_WITH_SELECTOR;
};
//# sourceMappingURL=index.js.map